import { action, observable, makeObservable, flow } from 'mobx';
import { Decimal } from 'decimal.js';
import { parseNumberByPrecision } from '../core/helpers/parseNumberByPrecision';
import { userService } from '../services/userService';

class UserInfoStore {
  selectedChip = 10;

  betAmount = null;

  userBalance = 0;

  limits = null;

  precision = 2;

  rate = 1;

  userId = '';

  currencyCode = '';

  margin = 2;

  rtp = 1 - this.margin / 100;

  quickBets = [];

  constructor() {
    makeObservable(this, {
      rtp: observable,
      rate: observable,
      userId: observable,
      margin: observable,
      quickBets: observable,
      precision: observable,
      betAmount: observable,
      userBalance: observable,
      selectedChip: observable,
      currencyCode: observable,
      limits: observable.deep,
      setHalve: action.bound,
      setRate: action.bound,
      setMargin: action.bound,
      setUserId: action.bound,
      setLimits: action.bound,
      setDouble: action.bound,
      setQuickBets: action.bound,
      setPrecision: action.bound,
      setBetAmount: action.bound,
      setSelectedChip: action.bound,
      setCurrencyCode: action.bound,
      setUserBalance: action.bound,
      increaseAmount: action.bound,
      setUserConfigs: action.bound,
      getBalance: flow,
    });
  }

  setCurrencyCode(code) {
    this.currencyCode = code;
  }

  setSelectedChip(value) {
    this.selectedChip = value;
  }

  setMargin(margin) {
    this.margin = margin;
    this.rtp = 1 - margin / 100;
  }

  setUserId(id) {
    this.userId = id;
  }

  setUserConfigs({ rate, balance, precision, limits, quickBets }) {
    this.setRate(rate);
    this.setUserBalance(balance);
    this.setPrecision(precision);
    this.setLimits(limits);
    this.setQuickBets(quickBets);
  }

  setRate(rate) {
    this.rate = rate;
  }

  setPrecision(precision) {
    this.precision = precision;
  }

  setLimits(limits) {
    this.limits = limits;
    this.betAmount = limits.minBet;
  }

  setUserBalance(balance) {
    this.userBalance = balance;
  }

  setBetAmount(betAmount) {
    this.betAmount = betAmount;
  }

  setDouble() {
    if (this.betAmount * 2 > this.limits.maxBet) {
      this.betAmount = this.limits.maxBet;
    }
    if (this.betAmount * 2 <= this.limits.maxBet) {
      this.betAmount = parseNumberByPrecision(this.betAmount, 2, this.precision);
    }
  }

  setHalve() {
    if (this.betAmount / 2 < this.limits.minBet) {
      this.betAmount = this.limits.minBet;
    }
    if (this.betAmount / 2 >= this.limits.minBet) {
      this.betAmount = parseNumberByPrecision(this.betAmount, 0.5, this.precision);
    }
  }

  setQuickBets(quickBets) {
    this.quickBets = quickBets;
  }

  increaseAmount(isIncrease) {
    const step = (isIncrease ? 1 : -1) * this.limits.minBet;
    let nextBetAmount = new Decimal(+this.betAmount).plus(step).valueOf();
    if (+nextBetAmount > this.limits.maxBet) {
      nextBetAmount = this.limits.maxBet;
    } else if (+nextBetAmount < this.limits.minBet) {
      nextBetAmount = this.limits.minBet;
    }
    this.betAmount = parseNumberByPrecision(nextBetAmount, 1, this.precision);
  }

  *getBalance(isFirst) {
    const {
      data: { result },
    } = yield userService.getBalance();
    if (result === 0 && isFirst) {
      setTimeout(() => {
        this.getBalance();
      }, 500);
    } else {
      this.setUserBalance(result.balance);
    }
  }
}

export const userInfoStore = new UserInfoStore();
